import type { ElementType } from 'react';
import { CdDivider } from '../../atoms/CdDivider';
import { CdLink } from '../../atoms/CdLink';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import { cx } from '../../utils';
import styles from './CdHelpStrip.module.scss';

export interface CdHelpStripLink {
  label: string;
  href: string;
}

export interface CdHelpStripProps {
  title: string;
  description?: string;
  links: CdHelpStripLink[];
  linkAs?: ElementType;
  tone?: 'plain' | 'brand';
  className?: string;
}

/** "Need a hand? · Help center → | Connect support →" strip. */
export const CdHelpStrip = ({
  title,
  description,
  links,
  linkAs,
  tone = 'plain',
  className,
}: CdHelpStripProps) => {
  return (
    <section className={cx(styles.strip, styles[tone], className)}>
      <div className={styles.copy}>
        <CdHeading level={2} size="lg">
          {title}
        </CdHeading>
        {description && <CdText variant="bodyLarge">{description}</CdText>}
      </div>
      <ul className={styles.links}>
        {links.map((link, i) => (
          <li key={link.href} className={styles.linkItem}>
            {i > 0 && <CdDivider orientation="vertical" className={styles.divider} />}
            <CdLink as={linkAs} href={link.href} withArrow>
              {link.label}
            </CdLink>
          </li>
        ))}
      </ul>
    </section>
  );
};
